import { Field, FieldProps, ErrorMessage } from "formik"
import { classNames } from "primereact/utils"
import { RadioButton } from "primereact/radiobutton"

const RadioField = ({ field, options, label, className, validation }: Props) => (
  <Field name={field} validate={validation}>
    {({ field: { name, value }, form, meta: { touched, error } }: FieldProps) => (
      <div className={classNames("field relative flex flex-col space-y-2", className)}>
        {label && (
          <label htmlFor={name} className="text-sm font-medium text-gray-500">
            {label}
          </label>
        )}
        <div
          className={classNames("flex w-full space-x-16", { "p-invalid": touched && error })}
          role="radiogroup"
          aria-label={label}
        >
          {options.map((option) => {
            const inputId = `${name}-${option.value}`
            return (
              <div key={option.value} className="flex items-center text-sm">
                <RadioButton
                  inputId={inputId}
                  name={name}
                  value={option.value}
                  onChange={(e) => form.setFieldValue(name, e.value)}
                  checked={value === option.value}
                />
                <label htmlFor={inputId} className="mx-2 flex w-full cursor-pointer text-gray-500">
                  {option.label}
                </label>
              </div>
            )
          })}
        </div>
        <div className="p-error field-error-spacing flex items-start">
          <ErrorMessage name={field}>{(msg) => <small>{msg}</small>}</ErrorMessage>
        </div>
      </div>
    )}
  </Field>
)

type Option = {
  label: string
  value: string
}

type Props = {
  field: string
  options: Option[]
  label?: string
  className?: string
  validation?(value: string): void
}

export { RadioField }
